import React, { useState } from 'react';

import { WpTooltip, WpTooltipTrigger, WpTooltipContent } from '../';

import { WpButton, WpButtonGroup } from '../../button';
import { WpCheckbox } from 'Wpds/components/checkbox';

const TooltipDocs = () => {
  const OnHover = () => (
    <>
      <h5>On Hover</h5>
      <WpButtonGroup>
        <WpTooltip>
          <WpTooltipTrigger>
            <WpButton variant="secondary">exit</WpButton>
          </WpTooltipTrigger>
          <WpTooltipContent>exit without saving</WpTooltipContent>
        </WpTooltip>
        <WpTooltip>
          <WpTooltipTrigger>
            <WpButton>save</WpButton>
          </WpTooltipTrigger>
          <WpTooltipContent>exit and save</WpTooltipContent>
        </WpTooltip>
      </WpButtonGroup>
    </>
  );

  const OnClick = () => (
    <>
      <h5>On Click</h5>
      <WpButtonGroup>
        <WpTooltip event="click" initialOpen>
          <WpTooltipTrigger>
            <WpButton variant="secondary">exit</WpButton>
          </WpTooltipTrigger>
          <WpTooltipContent>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
          </WpTooltipContent>
        </WpTooltip>
        <WpTooltip event="click">
          <WpTooltipTrigger>
            <WpButton>save</WpButton>
          </WpTooltipTrigger>
          <WpTooltipContent>exit and save</WpTooltipContent>
        </WpTooltip>
      </WpButtonGroup>
    </>
  );

  const Controlled = () => {
    const [open, setIsOpen] = useState(false);

    return (
      <>
        <h5>Controlled</h5>
        <WpCheckbox id="cb" label="Open tooltip" checked={open} onChange={setIsOpen} />
        <WpTooltip open={open}>
          <WpTooltipTrigger>
            <WpButton variant="secondary">exit</WpButton>
          </WpTooltipTrigger>
          <WpTooltipContent>exit without saving</WpTooltipContent>
        </WpTooltip>
      </>
    );
  };

  return (
    <div>
      <br />
      <OnHover />
      <br />
      <br />
      <OnClick />
      <br />
      <br />
      <Controlled />
    </div>
  );
};

export default TooltipDocs;
